if (!customElements.get("td-add-to-cart")) {
  class TdAddToCart extends HTMLElement {
    constructor() {
      super();

      this.cartUrl = this.getAttribute('cart-url');
      this.productId = this.getAttribute('product-id');
      this.cartAction = document.getElementById('PageContainer').dataset.cartAction;
    }

    connectedCallback() {
      this.querySelector('.td-atc__button').addEventListener('click', this.handleButtonClick);
    }

    handleButtonClick = async (event) => {
      event.preventDefault();

      this.currentButton = event.currentTarget;

      // Display loading spinner & disable button
      this.disableButton();

      try {
        const formData = new FormData();
        formData.append('id', this.productId);

        const response = await fetch(`${this.cartUrl}/add.js`, {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        // Update cart drawer
        await this.updateCart();

        // Show added state
        this.addedButton();

        // Reset button text after 2 seconds
        setTimeout(() => this.enableButton(), 2000);

      } catch (error) {
        console.error('Unable to add to cart:', error);
        this.enableButton();
      }
    }

    updateCart = async () => {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      if (this.cartAction == 'drawer') {
        window.wetheme.toggleRightDrawer('cart', true, { cart: cart });
      } else {
        window.wetheme.updateCartDrawer(cart);
      }
    }

    disableButton = () => {
      this.currentButton.disabled = true;
      this.currentButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="spin flex m-0-auto" width="20px" height="20px" fill="currentColor"><path d="M201.1 71.9C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1l18.3-61.3C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6l18.3 61.3z"/></svg><span class="sr-only">Loading</span>`;
    }

    enableButton = () => {
      this.currentButton.disabled = false;
      this.currentButton.innerHTML = 'Add to Cart';
    }

    addedButton = () => {
      this.currentButton.innerHTML = 'Added!';
    }
  }
  
  customElements.define('td-add-to-cart', TdAddToCart);
}